import { render, staticRenderFns } from "./CmgRewardsExclusivePill.vue?vue&type=template&id=61fccb77&scoped=true&lang=pug&"
import script from "./cmg-rewards-exclusive-pill.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-exclusive-pill.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsExclusivePill.vue?vue&type=style&index=0&id=61fccb77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fccb77",
  null
  
)

export default component.exports